export default "__VITE_ASSET__Qex4ywgL__"